import { useAiSaasInputContainer } from "../container";
import LoadingOutline from "@views/components/LoadingOutline";
import css from "./index.module.scss";

export function InputLoading() {
  const { aiSaasProps } = useAiSaasInputContainer();

  if (!aiSaasProps.runAllLoading || aiSaasProps.saasUIInputData?.length !== 1) {
    return null;
  }

  return (
    <div className={css["saas-loading"]}>
      <LoadingOutline />
    </div>
  );
}
